module.exports = __webpack_public_path__ + "img/dashboard.bb956bdb.svg";